import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, ref, watch } from 'vue';

import GiftItemColors from '@/ui/shared/GiftItemColors.vue';
import GiftWithPurchaseColorViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.GiftWithPurchaseColorViewObject;
import UpdateGiftWithPurchaseVariantWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateGiftWithPurchaseVariantWebRequest;
import ServerContextService from '@/core/server-context.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniBasketGiftItemB2C',
  props: {
    item: null,
    vatText: null,
    showVatText: { type: Boolean },
    openedDetails: { type: Boolean }
  },
  emits: ["toggle-open"],
  setup(__props: any, { emit }: { emit: ({(e: 'toggle-open', item: LineItemViewObject, isOpen: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {item: LineItemViewObject, vatText?: string, showVatText: boolean, openedDetails?: boolean}





function updateGiftWithPurchaseItem(request: UpdateGiftWithPurchaseVariantWebRequest) {
    store.dispatch('basket/updateGiftWithPurchaseItem', request);
}

const colorPickerColors = computed<IColorBaubles[]>(() => allowsUpdate.value
    ? props.item.giftWithPurchase.colorScheme.map(color => ({
        colorImage: color.colorImage,
        hex: color.hex
    }))
    : []);

function setSelectedColor(color: GiftWithPurchaseColorViewObject) {
    const variant = props.item.giftWithPurchase.colorScheme.find(c => c.hex === color.hex);
    if (!variant || variant.variantCode === props.item.variantId) {
        return;
    }
    updateGiftWithPurchaseItem({ variantId: variant.variantCode, promotionId: props.item.giftWithPurchase.promotionId });
}
const allowsUpdate = computed<boolean>(() => props.item.giftWithPurchase.colorScheme && props.item.giftWithPurchase.colorScheme.length && props.item.giftWithPurchase.colorScheme.every(color => !!color.hex));

const showErrorImage = ref<boolean>(false);
const showSpinner = ref<boolean>(true);

function imageSuccess() {
    showErrorImage.value = false;
    showSpinner.value = false;
}

function imageError() {
    showErrorImage.value = true;
    showSpinner.value = false;
}

function showDeliveryTime(deliveryTime) {
    if (isJapanMarket) {
        return deliveryTime !== 'Labels.LP.Shared.DeliveryTimes.Code';
    }

    return true;
}

const locale = ServerContextService.languages.find(l => l.isSelected).code;
const isJapanMarket = locale.toLowerCase() === 'ja-JP'.toLowerCase();
const showColors = ref<boolean>(props.openedDetails || true);
watch(() => showColors.value, (value) => {
    emit('toggle-open', props.item, value);
});

return { __sfc: true,props, emit, updateGiftWithPurchaseItem, colorPickerColors, setSelectedColor, allowsUpdate, showErrorImage, showSpinner, imageSuccess, imageError, showDeliveryTime, locale, isJapanMarket, showColors, GiftItemColors }
}

})